var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("b-row", [_c("b-col", [_c("h2", [_vm._v("Relatório PDV")])])], 1),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-3", attrs: { "align-v": "end" } },
          [
            _c(
              "b-col",
              [
                _c("label", [_vm._v("Data Início")]),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { config: _vm.datePickerConfig },
                  model: {
                    value: _vm.fromDate,
                    callback: function($$v) {
                      _vm.fromDate = $$v
                    },
                    expression: "fromDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              [
                _c("label", [_vm._v("Data Fim")]),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { config: _vm.datePickerConfig },
                  model: {
                    value: _vm.toDate,
                    callback: function($$v) {
                      _vm.toDate = $$v
                    },
                    expression: "toDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("b-col", [
              _c("label", [_vm._v("Tipo de Relatório")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tipo,
                      expression: "tipo"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.tipo = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", [_vm._v(" Selecione um tipo")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "A" } }, [
                    _vm._v("Analítico")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "S" } }, [_vm._v("Sintético")])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.geraRelatorio()
                      }
                    }
                  },
                  [_vm._v("\n                    Gerar\n                ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b17ac44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b17ac44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/PDV.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5b17ac44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/PDV.vue
// module chunks = 2